import { render, staticRenderFns } from "./StatGrid.vue?vue&type=template&id=4195b4da&scoped=true"
import script from "./StatGrid.vue?vue&type=script&lang=js"
export * from "./StatGrid.vue?vue&type=script&lang=js"
import style0 from "./StatGrid.vue?vue&type=style&index=0&id=4195b4da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4195b4da",
  null
  
)

export default component.exports